import { FC } from 'react';
import styled from 'styled-components';

type LeftPanelContractModalProps = {
  backgroundColor?: string;
  color?: string;
};

const LeftPanelContractModal: FC<LeftPanelContractModalProps> = (props) => {
  return (
    <Wrapper
      data-testid='left-panel-contract-modal'
      color={props.color}
      backgroundColor={props.backgroundColor}
    >
      <Children padding='0'>{props.children}</Children>
    </Wrapper>
  );
};

export default LeftPanelContractModal;

const Wrapper = styled.div.attrs<LeftPanelContractModalProps>({})<LeftPanelContractModalProps>`
  background-color: ${(props) => props.backgroundColor ?? 'transparent'};
  width: 300px;
  height: 100%;
`;

type ContainerProps = {
  padding: string;
};

const Children = styled.div.attrs<ContainerProps>({
  className: 'container-fluid',
})<ContainerProps>`
  ${(props) =>
    props.padding &&
    `
            padding: ${props.padding}px;
        `};
`;
